import React, {Component} from 'react';
import {Field} from "redux-form";
import PropTypes from 'prop-types';

import Aux from '../../containers/AuxContainer'

class CheckboxGroup extends Component {

  field = ({input, meta, options, className}) => {

    const {name, onChange, onBlur, onFocus} = input;
    const {touched, error} = meta;

    // if (this.props.selected_role != null && this.props.selected_role.length > 0){
    //   input.value = this.props.selected_role;
    // }

    const checkboxes = options.map((role, index) => {

    const handleChange = (event) => {
      const inputValue = input.value;
      const arr = [...inputValue];

      if (event.target.checked) {
        arr.push(role.id);
      }
      else {
        arr.splice(arr.indexOf(role.id), 1);
      }
      onBlur(arr);
      console.log('Value', arr);
      return onChange(arr);
    };

    
      
      
    return (
      <label className="row" key={`checkbox-${index}`}>
        <div className="small-2 medium-1 column text-center custom-checkbox">

          <input 
            className={className}
            type="checkbox" 
            id={`${name}[${index}]`}
            name={`${name}[${index}]`} 
            value={role.id} 
            checked={input.value.includes(role.id) || (this.props.selected_role.indexOf(role.id) > -1)} 
            onChange={handleChange}
            onFocus={onFocus} />

          <label htmlFor={`${name}[${index}]`}>{role.id}</label>
          
        </div>
        <div className="small-2 medium-1 column text-center">
          <i className="fa fa-user-o"></i>
        </div>
        <div className="small-8 medium-10 column">
          { role.age_to == 100 &&
              <p className="role">{`${role.name} ${role.gender} / ${role.age_from}+ years`}</p>
          }
          { role.age_to < 100 &&
              <p className="role">{`${role.name} ${role.gender} / ${role.age_from}-${role.age_to} years`}</p>
          }
          <p className="role-description">{role.description}</p>
        </div>
      </label>
    );

  });

  return (
    <Aux>
      <div>{checkboxes}</div>
      { touched && error && <p className="form-error is-visible text-center">{error}</p>}
    </Aux>
  );};

  render() {
    return <Field {...this.props} type="checkbox" component={this.field} value={this.props.selected_role}/>;
  }
}


// Available props and the expected data types
// CheckboxGroup.propTypes = {
//   options: PropTypes.arrayOf(PropTypes.shape({
//     label: PropTypes.string.isRequired,
//     value: PropTypes.string.isRequired
//   })).isRequired
// }

export default CheckboxGroup


// WEBPACK FOOTER //
// ./src/components/forms/CheckboxGroup.js